export default __webpack_public_path__ + "24fc42067bc9ab315f11c73a10fe13aa.png";